import { addUniquenotEmptyElements } from "../../helpers";
export class AllLeaguesRetriever {
    constructor(bffGateway, dataProvider, loadedData) {
        this.bff = bffGateway;
        this.dataProvider = dataProvider;
        this.requestAllLeagues = {};
        this.requestAllLeagues.ids = [dataProvider.sportId];
        this.requestAllLeagues.regionIds = addUniquenotEmptyElements(this.dataProvider.regionId || []);
        this.loadedData = loadedData;
    }
    setRegionIds(regionId) {
        this.requestAllLeagues.regionIds = addUniquenotEmptyElements(this.dataProvider.regionId.concat(regionId));
    }
    removeRegionId() {
        this.requestAllLeagues.regionIds = [this.dataProvider.regionId[0]];
    }
    loadData() {
        this.bff.getLeaguesBySportId(this.requestAllLeagues)
            .then(response => this.loadDataSuccessCb(response))
            .catch(err => { console["log"](err); });
    }
    loadDataSuccessCb(response) {
        if (response.leagues && response.leagues.length) {
            this.loadedData(response.leagues);
        }
    }
}
//# sourceMappingURL=AllLeaguesRetriever.js.map